import { render, staticRenderFns } from "./LeaderboardWidget.vue?vue&type=template&id=91388dc4"
import script from "./LeaderboardWidget.vue?vue&type=script&lang=js"
export * from "./LeaderboardWidget.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardWidget.vue?vue&type=style&index=0&id=91388dc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports